/*
  2-element Layout component

  Desktop (> 960px)                 Mobile(<=960 px)
  +--------------------------+     +--------------+
  |                          |     |  +--------+  |
  |  +--------+  +--------+  |     |  | el 1   |  |
  |  |        |  |        |  |     |  |        |  |
  |  | el 1   |  | el 2   |  |     |  +--------+  |
  |  +--------+  +--------+  |     |  +--------+  |
  |                          |     |  | el 2   |  |
  +--------------------------+     |  |        |  |
                                   |  +--------+  |
                                   +--------------+
*/

import React from "react";
import "./styles.scss";

interface TwoElementsLayoutProps {
  firstElement: React.ReactNode;
  secondElement: React.ReactNode;

  firstElementFlex?: number;
  secondElementFlex?: number;
}

export const LayoutTwoElements: React.FC<TwoElementsLayoutProps> = ({
  firstElement,
  secondElement,

  firstElementFlex = 1,
  secondElementFlex = 1
}) => (
  <div className="layout-two-elements">
    <div
      className="layout-two-elements__first-element"
      style={{ flex: firstElementFlex }}
    >
      {firstElement}
    </div>
    <div
      className="layout-two-elements__second-element"
      style={{ flex: secondElementFlex }}
    >
      {secondElement}
    </div>
  </div>
);
